import React from 'react'
import styled, { css } from 'styled-components'
import { Loader } from 'libs/shared/ui-components/src/atoms'
import BuildingsCharts from './BuildingsCharts'
import BuildingsMap from './BuildingsMap'
import BuildnigsDataList from './BuildnigsDataList/BuildingsDataList'
import BuildingsType from './BuildingsType/BuildingsType'
import { IBuildingsTileDataType } from './@types/IBuildingsTileData'

const Wrapper = styled.div(({ theme }) => {
  const { palette } = theme
  return css`
    display: grid;
    flex-direction: column;
    padding: 1.25rem 1.5rem;
    background-color: ${palette.light.white};
  `
})

export const BuildingsTile: React.FC<{data: IBuildingsTileDataType, tileId: string}> = ({
  data, tileId,
}) => {
  const {
    buildingTypes,
    buildings,
  } = data?.value?.buildings?.basicData || {}
  const {
    buildingTypes: compareBuildingTypes,
    buildings: compareBuildings,
  } = data?.value?.comparedLocation?.buildings?.basicData || {}

  if (!data || data?.loading) return <Loader />

  return (
    <Wrapper>
      <BuildnigsDataList data={data || {}} />
      <BuildingsCharts
        density={buildings.density}
        distribution={buildingTypes.distribution}
        distributionArea={buildingTypes.distributionArea}
        showComparedAddress={!!data?.value.comparedLocation}
      />
      {compareBuildings && compareBuildingTypes
        ? (
          <BuildingsCharts
            compared
            density={compareBuildings?.density}
            distribution={compareBuildingTypes?.distribution}
            distributionArea={compareBuildingTypes?.distributionArea}
            showComparedAddress
          />
        )
        : null}

      <BuildingsType
        additionalData={data?.value || {}}
        tileId={tileId}
      />

      <BuildingsMap
        data={data?.value?.buildings}
        showComparedAddress={!!data?.value?.comparedLocation}
        tileId={tileId}
      />
      {data?.value?.comparedLocation
        ? (
          <BuildingsMap
            compared
            comparedData={data?.value?.comparedLocation?.buildings}
            data={data?.value?.buildings}
            showComparedAddress
            tileId={tileId}
          />
        )
        : null}
    </Wrapper>
  )
}
